import { render, staticRenderFns } from "./FForm.vue?vue&type=template&id=32f6b59a&scoped=true"
import script from "./FForm.vue?vue&type=script&lang=ts"
export * from "./FForm.vue?vue&type=script&lang=ts"
import style0 from "./FForm.vue?vue&type=style&index=0&id=32f6b59a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f6b59a",
  null
  
)

export default component.exports